module.exports = __webpack_public_path__ + "img/act-of-emotion-process-4.72ee1f00.jpg";